import React from "react";
import { IActivityUpdate } from "../../../vm";
import { ToastContext } from "../../common/ToastProvider";
import CustomDrawer from "../../common/CustomDrawer";
import {
  DefaultButton,
  PrimaryButton,
  Stack,
  TextField,
  Label,
  TagPicker,
  ITag,
  IBasePickerSuggestionsProps,
  Callout,
  Calendar,
  FocusTrapZone,
  DayOfWeek,
  DirectionalHint,
} from "@fluentui/react";
import { Formik } from "formik";
import {
  addActivityUpdates,
  updateActivityUpdates,
} from "../../../services/customers/CustomerService";
import { childrenGap, DayPickerStrings } from "../../common/Constants";
import * as yup from "yup";
import { parseJwt } from "../../../services/UtilService";
import moment from "moment";

let calendarButtonElement: HTMLElement;
const aUSchema = yup.object().shape({
  content: yup.string().required("required"),
});

export interface ManageAUDialogProps {
  data?: IActivityUpdate;
  handleLoading: any;
  handleDialogClose: any;
  customerId: string;
  datacenterDropdown: ITag[];
}

const ManageAUDialog: React.FC<ManageAUDialogProps> = ({
  data,
  handleDialogClose,
  handleLoading,
  customerId,
  datacenterDropdown,
}) => {
  //state
  const [state, setState] = React.useState({
    activityUpdate: {
      content: "",
      customerId: customerId,
      datacenterIds: [],
      date: moment().subtract(1, "month").toDate(),
      ...data,
    },
    isLoading: false,
    selectedDatacenters: [],
  } as {
    activityUpdate: IActivityUpdate;
    isLoading: boolean;
    selectedDatacenters: ITag[];
  });
  const [showCallender, setShowCallender] = React.useState(false as boolean);

  React.useEffect(() => {
    let datacenterIds = data?.datacenterIds || [];
    const tokenData = parseJwt();
    if (
      tokenData.role === 1 ||
      (tokenData.isAdmin === false && tokenData.role === 0)
    ) {
      if (datacenterIds.length === 0) {
        // datacenterIds = [tokenData.datacenterId];
        datacenterIds = tokenData.datacenterIds;
      }
    }
    if (datacenterIds && datacenterIds.length > 0) {
      let selectedDatacenters: any = []
      datacenterIds.forEach((d) => {
        let found = datacenterDropdown.find((e) => e.key === d);
        if (found) {
          selectedDatacenters.push(found);
        }
      });
      setState({
        ...state,
        selectedDatacenters,
        activityUpdate: { ...state.activityUpdate, datacenterIds },
      });
    }
    console.log("DC", datacenterDropdown);
  }, []);

  console.log("data", data);

  //hooks
  const { showToast } = React.useContext(ToastContext);

  const closeAddDialog = (data?: IActivityUpdate) => {
    handleDialogClose(data);
  };

  const pickerSuggestionsProps: IBasePickerSuggestionsProps = {
    noResultsFoundText: "No datacenter found",
  };

  const filterSuggestedTags = (filterText: string, tagList: ITag[]): ITag[] => {
    let allDataCenterList = [...datacenterDropdown];

    return filterText
      ? allDataCenterList.filter(
        (tag) =>
          tag.name.toLowerCase().indexOf(filterText.toLowerCase()) === 0 &&
          !listContainsTagList(tag, tagList)
      )
      : [];
  };

  const showAllTags = (selectedItems?: ITag[] | undefined) => {
    let allDataCenterList = [...datacenterDropdown];
    return removeDuplicates(allDataCenterList, selectedItems);
  };

  function removeDuplicates(tagList: ITag[], tags?: ITag[]) {
    return tagList.filter((tag) => !listContainsTagList(tag, tags));
  }

  const listContainsTagList = (tag: ITag, tagList?: ITag[]) => {
    if (!tagList || !tagList.length || tagList.length === 0) {
      return false;
    }
    return tagList.some((compareTag) => compareTag.key === tag.key);
  };

  const closeCallender = () => {
    setShowCallender(false);
  };

  const isDisabled = () => {
    if (data?._id) {
      const tempTimestamp = new Date(data.date).valueOf();
      const currentTimeStamp = moment().subtract(1, "month").startOf("month").startOf("day").toDate().valueOf();
      if (tempTimestamp < currentTimeStamp) {
        return true;
      }
      return false
    }
    return false
  }

  return (
    <React.Fragment>
      <CustomDrawer
        title={
          state.activityUpdate._id
            ? "Update Activity Updates"
            : "Add Activity Updates"
        }
        handelOpen={true}
        onClose={() => closeAddDialog()}
      >
        <Stack>
          <Formik
            initialValues={state.activityUpdate}
            validationSchema={aUSchema}
            onSubmit={async (values: IActivityUpdate, { setSubmitting }) => {
              let obj = { ...values };
              let result;
              handleLoading();
              if (state.activityUpdate._id) {
                result = await updateActivityUpdates(obj);
              } else {
                result = await addActivityUpdates(obj);
              }
              handleLoading();
              if (result.success) {
                closeAddDialog(result.data);
              } else {
                showToast(
                  result?.message ||
                  `Error while ${state.activityUpdate._id ? "updating" : "adding"
                  } activity updates`,
                  "error"
                );
              }
              setSubmitting(false);
            }}
          >
            {({
              handleSubmit,
              values,
              errors,
              touched,
              handleChange,
              setFieldValue,
              handleBlur,
            }) => (
              <form onSubmit={handleSubmit}>
                <Stack wrap tokens={childrenGap} className="pt-16">
                  <Stack.Item className="custom-multiline-textfield">
                    <TextField
                      name="content"
                      value={values.content}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      multiline
                      // rows={5}
                      label="Content"
                      errorMessage={
                        errors.content && touched.content ? errors.content : ""
                      }
                      disabled={isDisabled()}
                      autoAdjustHeight
                    />
                  </Stack.Item>
                  <br />
                  <Stack.Item>
                    <Stack horizontal tokens={childrenGap} >
                      <Stack.Item>
                        <div
                          ref={(calendarBtn) =>
                            (calendarButtonElement = calendarBtn!)
                          }
                        >
                          <DefaultButton
                            text={
                              !values.date
                                ? "Select a month"
                                : moment(values.date).format("MMM-YYYY")
                            }
                            onClick={() => setShowCallender(true)}
                            className="month-picker-btn"
                          />
                        </div>
                        {showCallender && !isDisabled() && (
                          <Callout
                            isBeakVisible={false}
                            gapSpace={0}
                            doNotLayer={false}
                            target={calendarButtonElement}
                            directionalHint={DirectionalHint.bottomLeftEdge}
                            onDismiss={() => closeCallender()}
                            setInitialFocus
                          >
                            <FocusTrapZone
                              firstFocusableSelector="ms-DatePicker-day--today"
                              isClickableOutsideFocusTrap
                            >
                              <Calendar
                                // eslint-disable-next-line react/jsx-no-bind
                                onSelectDate={(
                                  date: Date | null | undefined
                                ) => {
                                  setFieldValue("date", date);
                                  setShowCallender(false);
                                }}
                                onDismiss={() => closeCallender()}
                                isMonthPickerVisible={true}
                                value={new Date(values.date)}
                                firstDayOfWeek={DayOfWeek.Sunday}
                                strings={DayPickerStrings}
                                isDayPickerVisible={false}
                                highlightCurrentMonth={false}
                                highlightSelectedMonth={true}
                                showMonthPickerAsOverlay={false}
                                showGoToToday={false}
                                minDate={moment().subtract(1, "month").toDate()}
                              />
                            </FocusTrapZone>
                          </Callout>
                        )}
                      </Stack.Item>
                      <Stack.Item className="custom-picker" grow={1}>
                        <Label>Datacenters</Label>
                        <TagPicker
                          itemLimit={1}
                          removeButtonAriaLabel="Remove"
                          defaultSelectedItems={state.selectedDatacenters}
                          onResolveSuggestions={filterSuggestedTags as any}
                          pickerSuggestionsProps={pickerSuggestionsProps}
                          onEmptyResolveSuggestions={showAllTags}
                          inputProps={{
                            placeholder: "Search a particular datacenter",
                          }}
                          onChange={(items: any) => {
                            let datacenterIds: string[] = [];
                            items.forEach((i: any) => {
                              datacenterIds.push(i.key);
                            });
                            setFieldValue("datacenterIds", datacenterIds);
                          }}
                          disabled={isDisabled()}
                        />
                      </Stack.Item>
                    </Stack>
                  </Stack.Item>

                  <Stack.Item>
                    <Stack
                      horizontal
                      wrap
                      tokens={childrenGap}
                      horizontalAlign="end"
                      className="pt-16"
                    >
                      <DefaultButton
                        text="Cancel"
                        onClick={() => closeAddDialog()}
                        className="borderless-btn"
                      />
                      <PrimaryButton
                        type="submit"
                        text={state.activityUpdate._id ? "Update" : "Add"}
                      />
                    </Stack>
                  </Stack.Item>
                </Stack>
              </form>
            )}
          </Formik>
        </Stack>
      </CustomDrawer>
    </React.Fragment>
  );
};

export default ManageAUDialog;
